/* セレクト */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import { KeyValue } from '../types/KeyValue';
import Messages from '../molecules/Messages';
import Paragraph from '../molecules/Paragraph';
import { addFallBackSource } from '../Common';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  value: string;
  name: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  suffix: string;
  handleBlur?: VoidFunction;
}

const Select: React.FC<Props> = ({
  id,
  label,
  need,
  sources,
  value,
  handleChange,
  name,
  message,
  help_msg,
  disabled,
  suffix,
  handleBlur,
}) => {
  const returnFormSelectJsx = () => {
    return suffix ? (
      <>
        <Row>
          <Col>
            <Form.Control
              id={id}
              as="select"
              className="form-select"
              onChange={handleChange}
              name={name}
              disabled={disabled}
              defaultValue={value}
              onBlur={handleBlur}
            >
              {addFallBackSource(sources).map((src) => {
                return (
                  <option key={src.key} value={src.key}>
                    {src.value}
                  </option>
                );
              })}
            </Form.Control>
          </Col>
          <Col md={2} lg={2} xl={2}>
            {suffix}
          </Col>
        </Row>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    ) : (
      <>
        <Form.Control
          id={id}
          as="select"
          className="form-select"
          onChange={handleChange}
          name={name}
          disabled={disabled}
          defaultValue={value}
          onBlur={handleBlur}
        >
          {addFallBackSource(sources).map((src) => {
            return (
              <option key={src.key} value={src.key}>
                {src.value}
              </option>
            );
          })}
        </Form.Control>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };
  const returnLabelJsx = () => {
    const hasValue = !!value?.trim();

    return suffix ? (
      <>
        {sources.map((src, index) => {
          if (typeof value !== 'undefined' && value !== null) {
            value = String(value);
          }
          if (src.key === value) {
            return <Paragraph key={index} label={hasValue ? `${src.value}${suffix}` : ''} />;
          }
        })}
      </>
    ) : (
      <>
        {sources.map((src, index) => {
          if (typeof value !== 'undefined' && value !== null) {
            value = String(value);
          }
          if (src.key === value) {
            return <Paragraph key={index} label={src.value} />;
          }
        })}
      </>
    );
  };
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={disabled ? returnLabelJsx() : returnFormSelectJsx()}
    />
  );
};

export default Select;
